module.exports = __webpack_public_path__ + "img/how-step-1.71a10a3a.png";